function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
class GqlOperationError extends Error {
    constructor(errors){
        const errorMessage = getMessageFromErorrs(errors);
        super(errorMessage);
        _define_property(this, "errors", void 0);
        this.errors = errors;
    }
}
export { GqlOperationError as default };
function getMessageFromErorrs(errors) {
    let errorMessage = '';
    if (errors.graphQlErrors.length > 0) {
        errorMessage = errors.graphQlErrors[0].message;
    } else if (errors.clientErrors.length > 0) {
        errorMessage = errors.clientErrors[0].message;
    } else if (errors.networkErrors.length > 0) {
        errorMessage = errors.networkErrors[0].message;
    } else {
        errorMessage = 'Unknown error';
    }
    return `There was an error in GraphQL operation, see the \`errors\` property for more details: ${errorMessage}`;
}

//# sourceMappingURL=GqlOperationError.js.map